import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "minutesToHoursDecimalCeil",
})
export class MinutesToHoursDecimalCeilPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(value: number, formatString?: string): string {
    return this.decimalPipe.transform(Math.ceil(value / 60 * 100) / 100, formatString);
  }
}
